import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Vacancy } from '../types';

export const FETCH_VACANCIES = 'FETCH_VACANCIES';
export type FETCH_VACANCIES = typeof FETCH_VACANCIES;

export const FETCH_VACANCIES_SUCCESS = 'FETCH_VACANCIES_SUCCESS';
export type FETCH_VACANCIES_SUCCESS = typeof FETCH_VACANCIES_SUCCESS;

export interface FetchVacancies {
    type: typeof FETCH_VACANCIES;
    payload: {
        request: AxiosRequestConfig;
    };
}

export interface FetchVacanciesSuccess {
    type: FETCH_VACANCIES_SUCCESS;
    payload: AxiosResponse<Vacancy[]>;
}

export const fetchVacancies = (): FetchVacancies => {
    const fetchVacanciesAction: FetchVacancies = {
        type: FETCH_VACANCIES,
        payload: {
            request: {
                url: '/administrator/vacancies'
            }
        }
    };
    return fetchVacanciesAction;
};



// WEBPACK FOOTER //
// ./src/scenes/administrator/actions/fetch-vacancies-action.ts